export const setLocalStorage = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorage = (key) => {
  const item = window.localStorage.getItem(key);
  if (item) {
    try {
      return JSON.parse(item);
    } catch (error) {
      return item;
    }
  }
  return null;
};

export const removeLocalStorage = (keys) => {
  keys.forEach((key) => {
    if (window.localStorage.getItem(key)) {
      window.localStorage.removeItem(key);
    }
  });
};

export const clearAllLocalStorage = () => {
  window.localStorage.clear();
};

// Token management
export const TOKEN_KEY = "auth_token";

export const setToken = (token) => {
  window.localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => {
  return window.localStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
  window.localStorage.removeItem(TOKEN_KEY);
};

export const hasToken = () => {
  return !!getToken();
};